import * as React from "react";
import TextareaAutosize, {
  TextareaAutosizeProps,
} from "react-textarea-autosize";

import {
  ColorContext,
  theme,
} from "@/components/canvas-editor/components/Container";
import { cn } from "@/lib/utils";

export interface TextareaProps extends TextareaAutosizeProps {
  onValueChange?: (value: string) => void;
  ref?: React.RefObject<HTMLTextAreaElement>;
}

const Textarea = ({
  className,
  onValueChange: onValueChangeProp,
  onChange,
  ...props
}: TextareaProps) => {
  const color = React.use(ColorContext);
  const onValueChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(e);
      onValueChangeProp?.(e.target.value);
    },
    [onValueChangeProp, onChange],
  );

  return (
    <TextareaAutosize
      className={cn(
        "text-slate-normal",
        "flex min-h-[80px] w-full rounded-md border border-slate-normal bg-slate-subtle px-3 py-2 text-base ring-offset-background placeholder:text-slate-dim focus-visible:outline-hidden focus-visible:ring-2  focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        theme.input[color || "default"],
        className,
      )}
      onChange={onValueChange}
      {...props}
    />
  );
};
Textarea.displayName = "Textarea";

export { Textarea };
